import { PAGE_LIMIT } from 'constants/index';
import { InvoicesPayload, InvoiceStatus } from 'generated/graphql';

export type State = {
  page: number;
  count: number;
  rowsPerPage: number;
  data: InvoicesPayload['data'];
  activeTab: string;
  search: string;
};

export const initialState: State = {
  page: 1,
  count: 0,
  data: [],
  rowsPerPage: PAGE_LIMIT,
  activeTab: InvoiceStatus.Paid,
  search: '',
};

export enum ActionType {
  SET_PAGE = 'setPage',
  SET_DATA = 'setData',
  SET_COUNT = 'setCount',
  SET_SEARCH = 'setSearch',
  SET_ACTIVE_TAB = 'setActiveTab',
  SET_ROWS_PER_PAGE = 'setRowsPerPage',
}

export type Action =
  | { type: ActionType.SET_PAGE; page: number }
  | { type: ActionType.SET_COUNT; count: number }
  | { type: ActionType.SET_ROWS_PER_PAGE; rowsPerPage: number }
  | { type: ActionType.SET_DATA; data: State['data'] }
  | { type: ActionType.SET_ACTIVE_TAB; activeTab: string }
  | { type: ActionType.SET_SEARCH; search: string };

export const invoicesReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionType.SET_PAGE:
      return {
        ...state,
        page: action.page,
      };

    case ActionType.SET_ROWS_PER_PAGE:
      return {
        ...state,
        rowsPerPage: action.rowsPerPage,
      };

    case ActionType.SET_COUNT:
      return {
        ...state,
        count: action.count,
      };

    case ActionType.SET_DATA:
      return {
        ...state,
        data: action.data,
      };

    case ActionType.SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.activeTab,
      };

    case ActionType.SET_SEARCH:
      return {
        ...state,
        search: action.search,
      };
  }
};
